module.exports = __webpack_public_path__ + "img/bybit_7.85002bcf.png";